var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"voltageOne",staticClass:"voltage-one",staticStyle:{"width":"100%","height":"calc(16vh)"},attrs:{"id":"voltageOne"}})
}
var staticRenderFns = []

export { render, staticRenderFns }